function validateFields(instance) {
    const result = {
        success: true,
        fieldsError: []
    };

    if (instance.location[0].value === undefined || instance.location[0].value === 0) {
        result.success = false;
        result.fieldsError.push(instance.location[0]);
        instance.location[0].setError();
    }

    if (instance.location[1].value === undefined || instance.location[1].value === 0) {
        result.success = false;
        result.fieldsError.push(instance.location[1]);
        instance.location[1].setError();
    }

    if (instance.calendar.input.value === '') {
        result.success = false;
        result.fieldsError.push(instance.calendar);
        instance.calendar.input.setError();
    }

    return result;
}

module.exports = {
    validateFields
};
